export default {
  title: 'Suggerimenti IA',
  subtitle: "Suggerimenti dell'agente FoodAmigos per i tuoi ristoranti.",
  empty: 'Niente da mostrare qui.',
  tabs: {
    pending: 'In attesa',
    history: 'Cronologia',
  },
  table: {
    id: 'ID',
    company: 'Ristorante',
    type: 'Tipo',
    summary: 'Suggerimento',
    created_at: 'Creato',
    status: 'Stato',
    actions: 'Azioni',
  },
  statuses: {
    pending: 'In attesa',
    confirmed: 'Confermato',
    applied: 'Applicato',
    rejected: 'Rifiutato',
    failed: 'Fallito',
    expired: 'Scaduto',
  },
  types: {
    'smart_pricing.global_reduce': "Sconto sull'intero menu",
    'smart_pricing.category_reduce': 'Sconto per categoria',
    'competitor_listing.confirm': 'Conferma inserzione marketplace',
    'catalog.price_correct': 'Correzione prezzi',
    'catalog.add_item': 'Aggiungi elemento mancante',
    'catalog.quality': 'Qualità contenuti',
    'catalog.reorder': 'Riordino menu',
  },
  actions: {
    review: 'Revisiona',
    confirm: 'Conferma',
    reject: 'Rifiuta',
    cancel: 'Annulla',
    edit: 'Modifica',
  },
  edit: {
    label: 'Descrivi la modifica desiderata (verrà generata una nuova revisione)',
    placeholder: 'Descrivi la modifica desiderata',
    placeholders: {
      'smart_pricing.global_reduce':
        'es. portarlo al 15%, rinominarlo in «Summer -15%», o applicarlo solo alla consegna',
      'smart_pricing.category_reduce': 'es. imposta lo sconto Bevande al 10% e rimuovi il ritiro',
      'catalog.price_correct': 'es. rimuovi la correzione «Cola», o imposta «Pizza» a €7,50',
      'catalog.add_item': "es. rimuovi l'elemento «Water», o imposta «Falafel Wrap» a €6,50",
      'catalog.quality': 'es. rimuovi gli elementi «Fries» e «Cola» dalla lista',
      'catalog.reorder': 'es. metti Bevande in fondo e sposta il bestseller in cima a Bowls',
      'competitor_listing.confirm': 'es. sostituisci il link Uber Eats con https://…, o aggiungi Wolt: https://…',
    },
    submit: 'Genera revisione',
  },
  revisions: {
    label: 'Revisione',
    original: 'Originale',
    revision_n: 'Revisione {{n}}',
  },
  detail: {
    title: 'Dettaglio suggerimento',
    targets: 'Elementi coinvolti',
    evidence: "Perché l'agente lo suggerisce",
    no_targets: 'Nessun dettaglio elemento disponibile.',
    composed_from: 'Composto da',
    items_suffix: 'elementi',
    nutrition: 'Valori nutrizionali',
    uncategorized: 'Non categorizzato',
    decided_by: 'Deciso da',
    decision_note: 'Nota',
    category_existing: 'esistente',
    category_new: 'nuovo',
    product: 'Prodotto',
    price_change: 'Variazione prezzo',
    no_items: 'Nessun elemento',
    fills_image: '+ immagine',
    fills_description: '+ descrizione',
    fills_nutrition: '+ nutrizione',
    fills_modifiers: '+ modificatori',
    competitor_links: 'Link concorrenti',
    no_competitor_links: 'Nessun link concorrente risolto.',
  },
  competitors: {
    lieferando: 'Lieferando',
    wolt: 'Wolt',
    deliveroo: 'Deliveroo',
    uber_eats: 'Uber Eats',
  },
  reject_modal: {
    title: 'Rifiuta questo suggerimento',
    note_label: 'Motivo',
    note_placeholder: 'Spiega brevemente perché stai rifiutando questo suggerimento',
  },
  toasts: {
    load_failed: 'Caricamento suggerimenti non riuscito',
    confirmed: 'Suggerimento confermato',
    rejected: 'Suggerimento rifiutato',
    action_failed: "Impossibile completare l'azione",
    revision_created: 'Nuova revisione generata',
    revision_failed: "Impossibile generare una revisione da quell'istruzione",
    choose_revision: 'Questo suggerimento ha più revisioni — aprilo e selezionane una da confermare',
  },
};
